var React = require(150)

var props = require(155)
var component = React.createFactory(require(156))
var element = component(props)

React.render(element, document)
